import { useRef } from 'react';

import { v4 as uuidv4 } from 'uuid';

const useRandom = (prefix = '') => {
  const random = useRef(`${prefix}${uuidv4()}`);

  return random.current;
};

export default useRandom;
